export default __webpack_public_path__ + "static/media/plus.d588da36.svg";